import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import { DeepNonNullable } from "ts-essentials";

type YoutubeProps = {
  src: string;
  locale?: string;
};

const YoutubeMovie = ({ src, locale }: YoutubeProps) => {
  const { site } = useStaticQuery<DeepNonNullable<Queries.SiteUrlDataQuery>>(
    graphql`
      query SiteUrlData {
        site {
          siteMetadata {
            siteUrl
          }
        }
      }
    `
  );
  const { location } =
    typeof window !== `undefined`
      ? window
      : { location: { pathname: undefined } };

  const videoLink = new URL(src).pathname;

  const sitePath = `${site.siteMetadata?.siteUrl}${location.pathname}`;
  return (
    <div className="video-frame relative grow overflow-hidden rounded-lg bg-accuRankerPurple-500 p-0">
      <iframe
        className="video m-0 block aspect-video w-full"
        allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture"
        controls={1}
        color="white"
        fs={1}
        hl={locale}
        cc_lang_pref={locale}
        src={`https://www.youtube-nocookie.com/embed/${videoLink}`}
        title="YouTube video player"
        iv_load_policy={3}
        modestbranding={1}
        allowfullscreen
        loading="lazy"
        rel={0}
        disablekb={0}
        widget_referrer={sitePath}
        frameborder="0"
      />
    </div>
  );
};

export default YoutubeMovie;
